export default "__VITE_ASSET__hk2Mai30__"